export { default } from './transparencyWidget'
